import { Container, Grid, Link, Typography } from '@material-ui/core'
import React from 'react'
import LinkList from '../LinkList';
import Logo from '../Logo'
import MyIconButton from '../MyIconButton';
import FooterTitle from './FooterTitle';
import useStyles from './styles'
import { FaFacebookF, FaFacebookMessenger } from 'react-icons/fa';
import { FiYoutube } from 'react-icons/fi';
import { AiFillGoogleCircle, AiFillInstagram } from 'react-icons/ai'

const Footer = () => {
    const classes = useStyles();
    return (
        <footer className={classes.content}>
            <Grid container spacing={5} className={classes.gridContainer}>
                <Grid item xs={12} md={6} lg={3}>
                    <Logo hide={false} />
                    <Typography variant='body1' className={classes.Typography}>
                        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Accusantium nostrum tempore, delectus voluptatem earum incidunt nemo? Libero obcaecati soluta, adipisci eius facere, architecto odit tempore eum iusto at impedit totam asperiores facilis blanditiis? Neque delectus earum dolores labore? Nisi, expedita.
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <FooterTitle title="About Us" />
                    <LinkList Links={['Careers', 'Our Store', 'Our Cares', 'Terms & Conditions', 'Privacy Policy']} />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <FooterTitle title="Customer Care" />
                    <LinkList Links={['Help Center', 'How to Buy', 'Track Your Order', 'Corporate & Bulk Purchasing', 'Returns & Refunds']} />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <FooterTitle title="Contact Us" />

                    <Typography variant='body2' className={classes.Typography} style={{ marginTop: '25px' }}>
                        Some Address here
                        <br />
                        <br />
                        Email: example.exmaple@weshooop.com

                        <br />
                        <br />
                        Phone: +1 1111 111 111
                    </Typography>

                    <Container style={{ padding: '0px' }}>
                        <MyIconButton Icon={<FaFacebookF />} />
                        <MyIconButton Icon={<FaFacebookMessenger />} />
                        <MyIconButton Icon={<FiYoutube />} />
                        <MyIconButton Icon={<AiFillGoogleCircle />} />
                        <MyIconButton Icon={<AiFillInstagram />} />
                    </Container>
                </Grid>

                <Grid item xs={12}>

                    <Typography variant='body2' className={classes.copyRight}>
                        Copyright ©&nbsp;
                        <Link
                            href="https://mustapha-el-mezziouy.vercel.app/"
                            underline="hover"
                            target="_blank"
                            rel="noreferrer"
                            style={{
                                color: '#1badde'
                            }}
                        >
                            Mustapha EL-MEZZIOUY
                        </Link>
                        &nbsp;
                        {new Date().getFullYear()}
                    </Typography>
                </Grid>
            </Grid>
        </footer>
    )
}

export default Footer